/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../../components/layout-components/Layout";
import SectionOne from '../../components/page-sections/faq/SectionOne';
import SectionTwo from "../../components/page-sections/faq/SectionTwo";

const Faqs = () => {
    return (
      <React.Fragment>
        <Layout>
          {/* Page Header */}
          <SectionOne />

          {/* FAQ Tabs */}
          <SectionTwo />
        </Layout>
      </React.Fragment>
    );
};

export default Faqs;
